export default __webpack_public_path__ + "static/media/check_small.09f2ee9b.svg";